import "./AboutInfraPM.module.css";
import Header from "@/reusable_sections/Header";
import Methodology from "./sections/Methodology";
import PublicSector from "./sections/PublicSector";
import Accountability from "./sections/Accountability";
import Footer from "@/reusable_sections/Footer";
export default function AboutInfraPMPage() {
  return <div>
      <Header />
      <Methodology />
      <PublicSector />
      <Accountability />
      <Footer />
    </div>;
}